<template>
    <x-text-field
        :name="name"
        v-model="num"
        :rules="fieldRules"
        :mask="mask"
        :hint="formattedNumber"
        :messages="messages"
        :persistent-hint=true
        :hide-details="hideDetails"
        :maxlength="maxLength"
        :disabled="disabled"
        :readonly="readonly"
        ref="currencyTextField"
        v-bind="$attrs"
        :label="label"
    />
</template>

<script>
import rules from "~/mixins/rules";

export default {
    inheritAttrs: false,
    name: 'XCurrencyTextField',
    mixins: [rules],
    props: {
        value: {},
        name: {},
        rules: {
            type: Array,
            required: false,
            default: () => []
        },
        currency: {},
        inputStyle: {},
        items: {},
        hideDetails: {
            type: Boolean
        },
        hideHelper: Boolean,
        disabled: {},
        readonly: {
            type: Boolean
        },
        mask: {},
        maxLength: {
            default: 18,
            type: Number
        },
        applyNumericRule: {
            type: Boolean,
            default: true
        },
        label: String,
        messages: {},
        optional: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        formattedNumber() {
            if (this.hideHelper) {
                return undefined;
            }

            return this.$options.filters.numberToEnglish(this.num);
        },
        num: {
            get () {
                return this.$options.filters.formatMoney(this.value, 2);
            },
            set (newValue) {
                const cleanNumber = (newValue === null || newValue === undefined || newValue.trim() === "") ? '' : parseFloat(newValue.toString().replace(/,/g, ''));
                !isNaN(cleanNumber) ? this.$emit('input', cleanNumber) : '';
            }
        },
        fieldRules() {
            const baseRules = [];

            if (this.optional) {
                baseRules.push(v => this.ruleOptionalNumericString(v, this.label || 'Field'));
            } else {
                baseRules.push(v => this.ruleNumericString(v, this.label || 'Field'));
            }

            return this.rules.concat(baseRules);
        }
    },
    watch: {
        num(newNum = '', oldNum = '') {
            if (!newNum) {
                newNum = '';
            }

            if (!oldNum) {
                oldNum = '';
            }
            // Keep the cursor in the correct position after formatting the number (1000 to 1,000 etc)
            const {input} = this.$refs.currencyTextField.$refs;
            const movement = (newNum.match(/,/g) || []).length - (oldNum.match(/,/g) || []).length;
            const newPos = input.selectionStart + movement;

            this.$nextTick(() => {
                input.selectionStart = newPos;
                input.selectionEnd = newPos;
            });
        }
    }
}
</script>
